(function () {
  'use strict';
  if (window.LPLPetParents) {
    window.LPLPetParents.init(document);
    return;
  }

  var roots = new Map();
  var activeVideo = null;
  var playSequence = 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pauseOthers(exception) {
    document.querySelectorAll('video').forEach(function (video) {
      if (video !== exception && !video.paused) video.pause();
    });
  }

  function initRoot(root) {
    if (roots.has(root)) return;
    var cleanups = [];
    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      cleanups.push(function () { target.removeEventListener(name, handler, options); });
    }

    root.querySelectorAll('[data-lpl-pp-video]').forEach(function (media) {
      var video = media.querySelector('video');
      var toggle = media.querySelector('.lpl-pp__toggle');
      var poster = media.querySelector('.lpl-pp__poster');
      var sound = media.querySelector('.lpl-pp__sound');
      var status = media.querySelector('.lpl-pp__status');
      var pending = false;
      var requestId = 0;
      if (!video || !toggle) return;

      function showState(playing) {
        media.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
        toggle.setAttribute('aria-label', (playing ? 'Pause ' : 'Play ') + toggle.dataset.storyName + ' testimonial');
        sound.hidden = !playing || !video.muted;
      }

      function activateSources() {
        if (video.dataset.sourcesReady === 'true') return;
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
        });
        video.dataset.sourcesReady = 'true';
        video.load();
      }

      function cancel() {
        requestId = ++playSequence;
        pending = false;
        video.pause();
        showState(false);
        if (activeVideo === video) activeVideo = null;
      }

      async function play() {
        pauseOthers(video);
        // Invalidate any pending request, including one waiting on a browser policy decision.
        var thisRequest = ++playSequence;
        requestId = thisRequest;
        video.dataset.lplPlayRequest = String(thisRequest);
        activeVideo = video;
        pending = true;
        status.textContent = '';
        activateSources();
        video.muted = false;
        try {
          await video.play();
        } catch (error) {
          if (thisRequest !== requestId || thisRequest !== playSequence || activeVideo !== video || !pending) return;
          if (error && error.name === 'NotAllowedError') {
            video.muted = true;
            try {
              await video.play();
            } catch (mutedError) {
              if (thisRequest === requestId && thisRequest === playSequence) {
                pending = false;
                showState(false);
                status.textContent = 'This video could not play. Please try again.';
              }
              return;
            }
          } else {
            pending = false;
            showState(false);
            status.textContent = 'This video could not play. Please try again.';
            return;
          }
        }
        if (thisRequest !== requestId || thisRequest !== playSequence || activeVideo !== video) {
          video.pause();
          return;
        }
        pending = false;
        showState(!video.paused);
      }

      listen(toggle, 'click', function () {
        if (pending || !video.paused) cancel();
        else play();
      });
      listen(sound, 'click', function () {
        video.muted = false;
        sound.hidden = true;
      });
      listen(video, 'playing', function () {
        if (activeVideo !== video) { video.pause(); return; }
        pauseOthers(video);
        if (poster) poster.hidden = true;
        showState(true);
      });
      listen(video, 'pause', function () {
        pending = false;
        showState(false);
      });
      listen(video, 'ended', function () {
        showState(false);
      });
      listen(video, 'volumechange', function () { showState(!video.paused); });
      listen(video, 'error', function () {
        pending = false;
        showState(false);
        if (poster && !video.currentTime) poster.hidden = false;
        status.textContent = 'This video could not load. Please try again.';
      });
      cleanups.push(cancel);
      toggle.disabled = false;
      showState(false);
    });

    var rail = root.querySelector('.lpl-pp__rail');
    var previous = root.querySelector('[data-direction="-1"]');
    var next = root.querySelector('[data-direction="1"]');
    if (rail && previous && next) {
      var arrowFrame = 0;
      function updateArrows() {
        arrowFrame = 0;
        // Read geometry together before writing changed control states.
        var left = rail.scrollLeft;
        var viewport = rail.clientWidth;
        var extent = rail.scrollWidth;
        var atStart = left <= 1;
        var atEnd = left + viewport >= extent - 1;
        if (previous.disabled !== atStart) previous.disabled = atStart;
        if (next.disabled !== atEnd) next.disabled = atEnd;
      }
      function scheduleArrows() {
        if (!arrowFrame) arrowFrame = window.requestAnimationFrame(updateArrows);
      }
      cleanups.push(function () { if (arrowFrame) window.cancelAnimationFrame(arrowFrame); });
      function move(direction) {
        var card = rail.querySelector('.lpl-pp__card');
        var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
        if (!card) return;
        rail.scrollBy({left: direction * 2 * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      }
      listen(previous, 'click', function () { move(-1); });
      listen(next, 'click', function () { move(1); });
      listen(rail, 'scroll', scheduleArrows, {passive: true});
      listen(rail, 'keydown', function (event) {
        if (event.target !== rail || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(scheduleArrows);
        resizeObserver.observe(rail);
        cleanups.push(function () { resizeObserver.disconnect(); });
      } else {
        listen(window, 'resize', scheduleArrows);
      }
      updateArrows();
    }

    roots.set(root, function () {
      cleanups.splice(0).forEach(function (cleanup) { cleanup(); });
      roots.delete(root);
    });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-lpl-pet-parents]')) initRoot(scope);
    scope.querySelectorAll('[data-lpl-pet-parents]').forEach(initRoot);
  }

  // Capture playback from other page sections too so there is only one playing video.
  document.addEventListener('play', function (event) {
    if (event.target.tagName !== 'VIDEO') return;
    var video = event.target;
    if (video.closest('[data-lpl-pp-video]')) {
      if (video.dataset.lplPlayRequest !== String(playSequence)) { video.pause(); return; }
    } else {
      playSequence += 1;
    }
    activeVideo = video;
    pauseOthers(video);
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      playSequence += 1;
      activeVideo = null;
      pauseOthers(null);
    }
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    roots.forEach(function (destroy, root) {
      if (event.target === root || event.target.contains(root)) destroy();
    });
  });
  window.LPLPetParents = {init: init};
  init(document);
})();
